const addressFragment = `
    id
    address1
    address2
    city
    country
    province
    zip
    zoneCode
    name
    firstName
    lastName
    phoneNumber
    territoryCode
`

const query = `query {
    customer {
        firstName
        lastName
        creationDate
        id
        emailAddress {
            emailAddress
        }
        phoneNumber {
            phoneNumber
        }
        addresses (first: 10) {
            edges {
                node {
                    ${addressFragment}
                }
            }
        }
        defaultAddress {
            ${addressFragment}
        }
        orders (first: 3, reverse: true) {
            edges {
                node {
                    id
                    fulfillments (first: 3) {
                        edges {
                            node {
                                fulfillmentLineItems (first: 3) {
                                    edges {
                                        node {
                                            lineItem {  
                                                image {
                                                    url
                                                    width
                                                    height
                                                }
                                                variantId
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    lineItems (first: 3) {
                        edges {
                            node {
                                image {
                                    url
                                }
                                variantId
                            }
                        }
                    }
                }
            }
        }
    }
}`

export default query
